export default "__VITE_ASSET__BgH6KwC___"